import React from "react";
import "./DateHighToLow.scss";
import useDateHighToLow from "../../../../../../hooks/useDateHighToLow";

const DateHighToLow = ({ data, role }) => {
  const { divideColumns, navigate } = useDateHighToLow();
  return (
    <div className="DateHighToLow-cont">
      {data && data.length ? (
        divideColumns(data).map((el, ind) => {
          return (
            <div className="DateHighToLow-cont__column" key={Math.random()}>
              {el}
            </div>
          );
        })
      ) : (
        <div className="emptyMyFeedback-cont">
          <p className="emptyMyFeedback-cont__text">
            You don't have any feedback yet
          </p>
        </div>
      )}
    </div>
  );
};

export default DateHighToLow;
